var map = {
	"./Matter-Bold.ttf": 35,
	"./Matter-Heavy.ttf": 36,
	"./Matter-Light.ttf": 37,
	"./Matter-Medium.ttf": 38,
	"./Matter-Regular.ttf": 39,
	"./Matter-SemiBold.ttf": 40,
	"./MatterSQ-Bold.ttf": 41,
	"./MatterSQ-Heavy.ttf": 42,
	"./MatterSQ-Light.ttf": 43,
	"./MatterSQ-Medium.ttf": 44,
	"./MatterSQ-Regular.ttf": 45,
	"./MatterSQ-SemiBold.ttf": 46,
	"./RecklessNeue-Bold.ttf": 47,
	"./RecklessNeue-Book.ttf": 48,
	"./RecklessNeue-Heavy.ttf": 49,
	"./RecklessNeue-Light.ttf": 50,
	"./RecklessNeue-Medium.ttf": 51,
	"./RecklessNeue-Regular.ttf": 52,
	"./RecklessNeue-SemiBold.ttf": 53,
	"./RecklessNeue-Thin.ttf": 54
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;